exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flex[data-v-07f94d2c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.meat-item[data-v-07f94d2c]{margin-bottom:16px}.meat-content[data-v-07f94d2c]  .el-card__header,.meat-content[data-v-07f94d2c]  .el-card__body{padding:4px 10px}.flex-col[data-v-07f94d2c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.mb-20[data-v-07f94d2c]{margin-bottom:20px}", ""]);

// exports
